import { ADMIN_ROLE_NAME } from '@utils/constants';
export const PRIVATE_SAVED_DASHBOARDS_KEY = 'pulse5';
export const PUBLIC_SAVED_DASHBOARDS_KEY = 'pulse5-public';
export const PULSE4_DASHBOARDS_KEY = 'pulse4';
export const PRIVATE_TEMP_DASHBOARDS_KEY = 'pulse5-temp';

export const tabList = [
  {
    key: PRIVATE_SAVED_DASHBOARDS_KEY,
    label: 'My Dashboards',
  },
  {
    key: PUBLIC_SAVED_DASHBOARDS_KEY,
    label: 'Public Dashboards',
  },
];

export const DataSourceMapping = {
  all: 'All',
  ai: 'Ad',
  ei: 'Video',
  app: 'App',
};

export const getDataModelDropdownItems = () => {
  return [
    {
      key: 'all',
      label: DataSourceMapping.all,
    },
    {
      key: 'ei',
      label: DataSourceMapping.ei,
    },
    {
      key: 'ai',
      label: DataSourceMapping.ai,
    },
    {
      key: 'app',
      label: DataSourceMapping.app,
    },
  ];
};

export const getBaseUrlByProduct = (productName: string) => {
  const product = (productName.toUpperCase() ||
    'EI') as keyof (typeof window)['conviva']['modules'];
  const moduleConfig = window.conviva.modules[product];
  return moduleConfig.baseUrl;
};

export const shouldShowShareInList = () => {
  return true;
};

export const shouldShowEditInList = (isPublic, dashboardData, userProfile) => {
  const userIsCreator = dashboardData.createdById === userProfile.profile_id;
  const userIsAdmin = userProfile.role === ADMIN_ROLE_NAME;
  return !isPublic || userIsCreator || userIsAdmin;
};

export const shouldShowDeleteInList = (isPublic, dashboardData, userProfile) => {
  const userIsCreator = dashboardData.createdById === userProfile.profile_id;
  return !isPublic || userIsCreator;
};
